
import { User } from "@supabase/supabase-js";

/**
 * Extract and validate tenant ID from user metadata
 */
export const extractAndValidateTenantId = (user: User): string => {
  const extractedTenantId = user.app_metadata?.tenant_id;
  
  if (!extractedTenantId) {
    // Tenant ID is essential, throw error if there is none
    throw new Error("Missing tenant ID in user metadata. Authentication failed.");
  }
  
  return extractedTenantId;
};

/**
 * Check if the user is an admin based on email domain
 * This is a simplified admin check - in a real app, this might check against
 * a specific email domain or list
 */
export const checkIfAdmin = (email: string | undefined): boolean => {
  if (!email) return false;
  // Check if the user is an admin based on email domain
  return email.endsWith("@martin-guenther.com");
};

/**
 * Determine tenant type from user email
 */
export const determineTenantType = (user: User): "admin" | "tenant" => {
  const email = user.email;
  return email && checkIfAdmin(email) ? "admin" : "tenant";
};
